import { render, staticRenderFns } from "./Fillscreen.vue?vue&type=template&id=51d23421&scoped=true&lang=html&"
import script from "./Fillscreen.vue?vue&type=script&lang=js&"
export * from "./Fillscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d23421",
  null
  
)

export default component.exports